style= require('./league-results.styl')

sporty-seasons(
  season=season,
  (change:season)=this.changeSeason(e),
  blank="<select a season>"
)
table
  thead
    tr
      th Rank
      th Team
      th Goals
      th Against
      th Diff
      th Points
      th Strength
  tbody
    each row in (season && season.tablePositions)
      if row.original && isDifferent(row, row.original)
        tr.row.original
          td.rank= row.original.rank
          td.name= row.original.name
          td.goals= row.original.goals
          td.against= row.original.against
          td.diff(class=diffClass(row.original.diff))= row.original.diff
          td.points= row.original.points
          td.strength= row.original.strength
      tr.row
        td.total
          ft-form-control(
            type="number",
            step="1",
            min="1",
            [(value)]=row.rank)
        td.name= row.name
        td.goals= row.goals
        td.against= row.against
        td.diff(class=diffClass(row.diff))= row.diff
        td.points= row.points
        td.strength
          ft-form-control(
            type="number",
            step="1",
            min="1",
            [(value)]=row.strength)
ft-button(
  bloat,
  success,
  (click)=this.save(teamTable)
) Save
